export class MessageAttachmentModel {
  messageAttachmentId: number;
  messageId: number;
  fileName: string;
  fileSize: number;

  constructor(data?: any) {
    this.messageAttachmentId = data?.messageAttachmentId ?? 0;
    this.messageId = data?.messageId ?? 0;
    this.fileName = data?.fileName ?? "";
    this.fileSize = data?.fileSize ?? 0;
  }
}